export const MODULE_NAME = 'product';

export const DEFAULT_PRODUCT_CONDITION = 'As good as new';

export * from './propTypes';
